import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    tasks: {
        url: `${customerApi}/api/group_chat_building`,
        type: 'GET',
    },
    // 新建
    create: {
        url: `${customerApi}/api/mass_sending`,
        type: 'POST',
    },
    // 客户数量
    customerCount: {
        url: `${customerApi}/api/customers/search`,
        type: 'POST',
    },
    // 过滤后的客户数量
    filterCustomerCount: {
        url: `${customerApi}/api/mass_sending/prepare`,
        type: 'POST',
    },
    remindUser: {
        url: `${customerApi}/api/group_chat_building/{id}/notify`,
        type: 'POST',
    },
    taskGroupChat: {
        url: `${customerApi}/api/group_chat_building/{id}/group_chats`,
        type: 'GET',
    },
    updateTaskGroupChat: {
        url: `${customerApi}/api/group_chat_building/{id}/group_chats`,
        type: 'PUT',
    },
    removeTaskGroupChat: {
        url: `${customerApi}/api/group_chat_building/{id}/group_chats/{group_chat_id}`,
        type: 'DELETE',
    },
    taskDetail: {
        url: `${customerApi}/api/group_chat_building/{id}`,
        type: 'GET',
    },
    taskSummary: {
        url: `${customerApi}/api/group_chat_building/{id}/summary`,
        type: 'GET',
    },
    detailListByCustomer: {
        url: `${customerApi}/api/group_chat_building/{id}/customer_details`,
        type: 'GET',
    },
    detailListByUser: {
        url: `${customerApi}/api/group_chat_building/{id}/user_details`,
        type: 'GET',
    },
}
